import { Link } from "react-router-dom";

const ContactButton = () => {
    return(
        <main>
            <section className='contact'>
                <Link to="/contact">
                    <button>お問い合わせはこちらから</button>
                </Link>
            </section>
        </main>
    )
}
export default ContactButton;